<ngx-spinner [fullScreen]="false" type="pacman" [name]="spinnerName" bdColor="rgba(51,51,51,0.3)"></ngx-spinner>

<div class="ap-container">

  @if (annexes.length > 0 || workerAgreement) {

    <!-- Dane podstawowe -->
    <div class="content-card">
      <h2 class="content-card__header">{{ 'AnnexPanel.SectionBasic' | translate }}</h2>
      <table>
        <tbody>
          <tr class="key-value-row">
            <td class="key-value-row__key">{{ 'AnnexPanel.Worker' | translate }}</td>
            <td class="key-value-row__value"><strong>{{ workerFullName }}</strong></td>
          </tr>
          @if (workerAgreement?.AgreementNumber) {
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'AnnexPanel.AgreementNumber' | translate }}</td>
              <td class="key-value-row__value">{{ workerAgreement.AgreementNumber }}</td>
            </tr>
          }
          @if (workerAgreement?.CompanyName) {
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'AnnexPanel.Company' | translate }}</td>
              <td class="key-value-row__value">{{ workerAgreement.CompanyName }}</td>
            </tr>
          }
          @if (workerAgreement?.EmployerObjectName) {
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'AnnexPanel.EmployerObject' | translate }}</td>
              <td class="key-value-row__value">{{ workerAgreement.EmployerObjectName }}</td>
            </tr>
          }
          @if (workerAgreement?.EmploymentTypeName) {
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'AnnexPanel.EmploymentType' | translate }}</td>
              <td class="key-value-row__value">{{ workerAgreement.EmploymentTypeName }}</td>
            </tr>
          }
          @if (workerAgreement) {
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'AnnexPanel.DateFrom' | translate }}</td>
              <td class="key-value-row__value">{{ workerAgreement.EmploymentDateFrom | date: 'dd.MM.yyyy' }}</td>
            </tr>
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'AnnexPanel.DateTo' | translate }}</td>
              <td class="key-value-row__value">
                @if (workerAgreement.EmploymentDateTo) {
                  {{ workerAgreement.EmploymentDateTo | date: 'dd.MM.yyyy' }}
                } @else {
                  {{ 'AnnexPanel.Indefinite' | translate }}
                }
              </td>
            </tr>
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'AnnexPanel.ConclusionDate' | translate }}</td>
              <td class="key-value-row__value">{{ workerAgreement.ConclusionDate | date: 'dd.MM.yyyy' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Aktualne dane umowy -->
    @if (workerAgreement) {
      <div class="content-card">
        <h2 class="content-card__header">{{ 'AnnexPanel.SectionCurrent' | translate }}</h2>
        <table>
          <tbody>
            @if (workerAgreement.Wages?.length) {
              <tr class="key-value-row">
                <td class="key-value-row__key">{{ 'AnnexPanel.ChangeWage' | translate }}</td>
                <td class="key-value-row__value"><strong>{{ formatWages(workerAgreement.Wages) }}</strong></td>
              </tr>
            }
            @if (workerAgreement.JobTitleName) {
              <tr class="key-value-row">
                <td class="key-value-row__key">{{ 'AnnexPanel.ChangeJobTitle' | translate }}</td>
                <td class="key-value-row__value">{{ workerAgreement.JobTitleName }}</td>
              </tr>
            }
            @if (workerAgreement.OrganizationalUnitName) {
              <tr class="key-value-row">
                <td class="key-value-row__key">{{ 'AnnexPanel.Unit' | translate }}</td>
                <td class="key-value-row__value">{{ workerAgreement.OrganizationalUnitName }}</td>
              </tr>
            }
            @if (workerAgreement.WorkingTimeGroupName) {
              <tr class="key-value-row">
                <td class="key-value-row__key">{{ 'AnnexPanel.WorkingTimeGroup' | translate }}</td>
                <td class="key-value-row__value">{{ workerAgreement.WorkingTimeGroupName }}</td>
              </tr>
            }
            @if (workerAgreement.PotentialSupervisorName) {
              <tr class="key-value-row">
                <td class="key-value-row__key">{{ 'AnnexPanel.ChangeSupervisor' | translate }}</td>
                <td class="key-value-row__value">{{ workerAgreement.PotentialSupervisorName }}</td>
              </tr>
            }
            @if (workerAgreement.TemporaryWorkplaceName) {
              <tr class="key-value-row">
                <td class="key-value-row__key">{{ 'AnnexPanel.ChangeTemporaryWorkplace' | translate }}</td>
                <td class="key-value-row__value">{{ workerAgreement.TemporaryWorkplaceName }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <!-- Lista aneksów -->
    @if (annexes.length > 0) {
    <div class="content-card">
      <h2 class="content-card__header">{{ 'AnnexPanel.SectionList' | translate }}</h2>

      <div class="ap-annex-list">
        @for (annex of annexes; track annex.AnnexId; let i = $index) {
          <div class="ap-annex-item" [class.ap-annex-item--open]="isOpen(annex.AnnexId)">
            <button class="ap-annex-head" type="button" (click)="toggleItem(annex.AnnexId)">
              <span class="ap-annex-title">
                <mat-icon class="ap-annex-chev">expand_more</mat-icon>
                {{ 'AnnexPanel.AnnexNumber' | translate : { number: annex.AnnexNumber } }}
              </span>
              <span class="ap-annex-badges">
                <span class="ap-status" [ngClass]="getStatusClass(annex.AnnexStatusId)">{{ annex.AnnexStatus }}</span>
                @if (isAdmin && annex.IsConsistent === false) {
                  <span
                    class="ap-inconsistent"
                    [matTooltip]="'AnnexPanel.Inconsistent' | translate"
                    matTooltipClass="annex-badge-tooltip"
                  >!</span>
                }
                <app-annex-imported-badge [visible]="annex.IsImported" />
              </span>
            </button>
            <div class="ap-annex-body">
              <div class="ap-annex-body__inner">
              <table>
                <tbody>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'AnnexPanel.DateFrom' | translate }}</td>
                    <td class="key-value-row__value">{{ annex.StartDate | date: 'dd.MM.yyyy' }}</td>
                  </tr>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'AnnexPanel.DateTo' | translate }}</td>
                    <td class="key-value-row__value">
                      @if (annex.EndDate) {
                        {{ annex.EndDate | date: 'dd.MM.yyyy' }}
                      } @else {
                        {{ 'AnnexPanel.Indefinite' | translate }}
                      }
                    </td>
                  </tr>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'AnnexPanel.ConclusionDate' | translate }}</td>
                    <td class="key-value-row__value">{{ annex.ConclusionDate | date: 'dd.MM.yyyy' }}</td>
                  </tr>
                  @if (getChangedAreas(annex).length > 0) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'AnnexPanel.Changes' | translate }}</td>
                      <td class="key-value-row__value">
                        <div class="ap-chip-list">
                          @for (area of getChangedAreas(annex); track area) {
                            <span class="ap-chip">{{ area | translate }}</span>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    }

    <!-- Nawigacja -->
    @if (annexes.length > 0 && showNavigationSection) {
    <div class="content-card content-card--nav">
      <h2 class="content-card__header">{{ 'AnnexPanel.SectionNav' | translate }}</h2>
      <table>
        <tbody>
          <tr class="key-value-row">
            <td class="key-value-row__key">{{ 'AnnexPanel.Registry' | translate }}</td>
            <td class="key-value-row__value">
              <button type="button" class="ap-link" (click)="navigateToAnnexRegistry()">
                {{ 'AnnexPanel.GoToRegistry' | translate }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    }

  }

</div>
